<script setup lang="ts">
const store = useAuthStore()
const loading = ref(false)

async function stop() {
  loading.value = true
  try {
    await $fetch('/api/admin/impersonate/stop', { method: 'POST' })
  }
  catch {
    // ignore
  }
  // Marquer qu'un reauth est necessaire pour les apps clientes
  // Le query param force les liens a passer par /api/auth/login
  window.location.href = '/?reauth=1'
}
</script>

<template>
  <div
    v-if="store.impersonating"
    class="bg-amber-500 text-white px-4 py-2 text-center text-sm font-medium flex items-center justify-center gap-3 z-[100]"
  >
    <UIcon name="i-lucide-eye" class="shrink-0" />
    <span>
      Connecte en tant que <strong>{{ store.user?.name }}</strong> ({{ store.user?.email }})
    </span>
    <UButton
      size="xs"
      variant="solid"
      color="neutral"
      icon="i-lucide-arrow-left"
      :loading="loading"
      @click="stop"
    >
      Revenir a mon compte
    </UButton>
  </div>
</template>
